import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { MoonIcon, CalendarIcon, HeartPulseIcon, SparklesIcon } from 'lucide-react';
export function SolutionSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full gradient-purple-soft py-20 px-4 sm:px-6 lg:px-8" data-id="element-222">
      <div className="max-w-6xl mx-auto" data-id="element-223">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-224">
          <div className="inline-block mb-6" data-id="element-225">
            <MoonIcon className="w-20 h-20 text-purple-main mx-auto moon-glow" data-id="element-226" />
          </div>
          <h2 className="text-purple-deep text-4xl sm:text-5xl md:text-6xl font-bold font-heading mb-6" data-id="element-227">
            Calendario{' '}
            <span className="font-script text-purple-main" data-id="element-228">
              "Fases Lunares"
            </span>
          </h2>
          <p className="text-gray-800 text-xl sm:text-2xl leading-relaxed max-w-4xl mx-auto font-semibold" data-id="element-229">
            Framework único: 7 templates fusionan ciclos luna (como abuelas
            decían) + trackers diarios para latinas USA.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="bg-white rounded-3xl p-8 sm:p-12 shadow-2xl mb-12" data-id="element-230">
          <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-231">
            <div className="text-center" data-id="element-232">
              <CalendarIcon className="w-16 h-16 text-purple-main mx-auto mb-4" data-id="element-233" />
              <h3 className="text-purple-deep text-2xl font-bold font-heading mb-2" data-id="element-234">
                Marca Patrones
              </h3>
              <p className="text-gray-700 text-lg" data-id="element-235">
                Calorones, sueño, humor —ve patrones invisibles
              </p>
            </div>
            <div className="text-center" data-id="element-236">
              <HeartPulseIcon className="w-16 h-16 text-coral mx-auto mb-4" data-id="element-237" />
              <h3 className="text-purple-deep text-2xl font-bold font-heading mb-2" data-id="element-238">
                Remedios Timed
              </h3>
              <p className="text-gray-700 text-lg" data-id="element-239">
                Manzanilla 8pm, lino desayuno —tu data dicta cambios
              </p>
            </div>
            <div className="text-center" data-id="element-240">
              <SparklesIcon className="w-16 h-16 text-sage mx-auto mb-4" data-id="element-241" />
              <h3 className="text-purple-deep text-2xl font-bold font-heading mb-2" data-id="element-242">
                Resultados Reales
              </h3>
              <p className="text-gray-700 text-lg" data-id="element-243">
                70% menos interrupciones noche en 28 días
              </p>
            </div>
          </div>

          <div className="bg-gradient-to-r from-coral/10 to-terracotta/10 rounded-2xl p-8 border-2 border-coral/30" data-id="element-244">
            <p className="text-gray-800 text-xl sm:text-2xl leading-relaxed text-center font-semibold" data-id="element-245">
              No teoría —tu data dicta cambios. Usado por 50+ mamás.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-center" data-id="element-246">
          <div className="inline-block bg-sage/20 rounded-full px-8 py-4 mb-6" data-id="element-247">
            <p className="text-purple-deep text-lg font-bold" data-id="element-248">
              ✨ En 7 días: María (47, LA) identificó "cena picante = 3
              calorones". Cambió —duerme seco.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}